import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { forkJoin } from 'rxjs';
import { AlertMessage } from 'src/app/template/models/alert-message.model';
import { EnrollmentNew } from 'src/app/modules/enrollments/models/enrollment-new.model';
import { Edition } from 'src/app/modules/editions/models/edition.model';
import { EditionService } from 'src/app/modules/editions/services/edition.service';
import { Student } from 'src/app/modules/students/models/student.model';
import { StudentService } from 'src/app/modules/students/services/student.service';
import { Known } from 'src/app/modules/knowns/models/known.model';
import { KnownService } from 'src/app/modules/knowns/services/known.service';

@Component({
  selector: 'app-enrollment-edit-step-campus',
  templateUrl: './enrollment-edit-step-campus.component.html',
  styleUrls: ['./enrollment-edit-step-campus.component.scss']
})
export class EnrollmentEditStepCampusComponent implements OnInit {

    @Input() enrollment: EnrollmentNew;

    @Output() enrollmentChange = new EventEmitter<EnrollmentNew>();
    @Output() isCompleteStep   = new EventEmitter<boolean>();

    public labels: any = {

        editionSelectorLabel: 'Seleccione la edición en la que desea realizar la inscripción',
        studentSelectorLabel: 'Seleccione el participante que desea matricular',
        knownSelectorLabel  : '¿Cómo nos ha conocido?',
        loadingErrorMessage : 'Se ha producido un error al cargar la página.'

    }

    public isLoadingData : boolean = true;
    public loadingMessage: AlertMessage = new AlertMessage();

    public editions: Edition[];
    public students: Student[];
    public knowns  : Known[];

    constructor(
        private editionService: EditionService,
        private studentService: StudentService,
        private knownService: KnownService) { }

    ngOnInit (): void {

        this.initData();

    }

    private initData() {

        forkJoin({

            editionsRequest: this.editionService.get(),
            studentsRequest: this.studentService.get(),
            knownsRequest  : this.knownService.get()

        }).subscribe({

            next: (requests: any) => {

                this.editions = requests.editionsRequest;
                this.students = requests.studentsRequest;
                this.knowns   = requests.knownsRequest;

            },

            error: (error: any) => {

                this.loadingMessage.showDangerAlert(this.labels.loadingErrorMessage);

            }

        }).add(() => {
            this.isLoadingData = false;
        });

    }

    public isFormValid() {

        let isValidStudent = this.enrollment.student && this.enrollment.student !== null;
        let isValidEdition = this.enrollment.edition && this.enrollment.edition !== null;
        let isValidKnown   = this.enrollment.known   && this.enrollment.known   !== null;

        return isValidStudent && isValidEdition && isValidKnown;

    }

    public onEnrollmentChange() {

        this.isCompleteStep.emit(this.isFormValid());
        this.enrollmentChange.emit(this.enrollment);

    }

}
